import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { System } from '../../shared-components/System';
import { FormListSequence, GoalData, IdentificationSubCodes, IepFormsWithinDocuments, ImportedDocuments, OptionalForms, PickCourseOfStudy, PickIdentification, PlaMaintenance, SpedTeamMemberUpdate, StudentCollectionTemplate, TeamMemberPermission } from './formwithin-document-modal';

@Injectable({
  providedIn: 'root'
})
export class FormWithinDocumentsService {

  goalData = new GoalData();
  pickIdentificationData = new PickIdentification();
  plaMiantenanceData = new PlaMaintenance();
  courceOfStudyData = new PickCourseOfStudy();
  spedStudentCollectionTemplate = new StudentCollectionTemplate();
  allOptionalFormChecked = false;
  callFromAlertDialog = false;
  editHtmlFormDialogOpen = false;

  private _selectedValueFromDD: any;
  public get selectedValueFromDD(): any {
    return this._selectedValueFromDD;
  }

  public set selectedValueFromDD(value: any) {
    this._selectedValueFromDD = value;
    this.observableSelectedValueFromDD.next(value);
  }

  public observableSelectedValueFromDD = new Subject<any>();
  observableSelectedValueFromDDStream$ = this.observableSelectedValueFromDD.asObservable();

  constructor(private http: HttpClient) { }

  spedStudentCollectionStatusTemplatesItemsRead(studentCollectionId: number, showLatestVersion: boolean, spEdcollectionId: number): Observable<IepFormsWithinDocuments[]> {
    const queryString = '?studentCollectionId=' + studentCollectionId + '&showLatestVersion=' + showLatestVersion + '&spEdcollectionId=' + spEdcollectionId;
    return this.http.get<IepFormsWithinDocuments[]>(System.apiURL.SpecialEd + 'SpedStudentCollectionStatusTemplatesItemsRead' + queryString);
  }

  spedStudentDocumentCreate(attachment: ImportedDocuments, attachmentType: string): Observable<ImportedDocuments[]> {
    // return this.http.post<ImportedDocuments[]>(System.apiURL.SpecialEd + 'SpedStudentDocumentCreate?attachmentType=${attachmentType}' , attachment);
    return this.http.post<ImportedDocuments[]>(System.apiURL.SpecialEd + `SpedStudentDocumentCreate?attachmentType=${attachmentType}`, attachment);
  }

  spedStudentDocumentRead(studentId: number, spedCollectionToStudentId: number): Observable<ImportedDocuments[]> {
    const queryString = '?studentId=' + studentId + '&spedCollectionToStudentId=' + spedCollectionToStudentId;
    return this.http.get<ImportedDocuments[]>(System.apiURL.SpecialEd + 'SpedStudentDocumentRead' + queryString);
  }

  spedStudentDocumentDelete(SpedDocumentId: number): Observable<ImportedDocuments[]> {
    const queryString = '?SpedDocumentId=' + SpedDocumentId;
    return this.http.post<ImportedDocuments[]>(System.apiURL.SpecialEd + 'SpedStudentDocumentDelete' + queryString, null);
  }

  spedHTMLStudentCollectionStatusTemplatesItemsRead(studentCollectionId: number, showLatestVersion: boolean, spEdcollectionId: number): Observable<IepFormsWithinDocuments[]> {
    let queryString = '';
    queryString += '?studentCollectionId=' + studentCollectionId +
      '&showLatestVersion=' + showLatestVersion +
      '&spEdcollectionId=' + spEdcollectionId;
    return this.http.get<IepFormsWithinDocuments[]>(System.apiURL.SpecialEd + 'SpedHTMLStudentCollectionStatusTemplatesItemsRead' + queryString);
  }

  saveGoalBankData(yearId: number): Observable<void> {
    let queryString = '';
    queryString += '?yearId=' + yearId;
    return this.http.post<void>(System.apiURL.SpecialEd + 'SaveGoalData' + queryString, this.goalData);
  }

  spedCopyAllowMultiple(studentCollectionId: number, spedTemplateVersionId: number): Observable<IepFormsWithinDocuments[]> {
    const queryString = '?studentCollectionId=' + studentCollectionId + '&spedTemplateVersionId=' + spedTemplateVersionId;
    return this.http.post<IepFormsWithinDocuments[]>(System.apiURL.SpecialEd + 'SpedCopyAllowMultiple' + queryString, null);
  }

  spedDeleteAssignedTemplate(spedStudentCollectionToTemplateVersionId: number): Observable<void> {
    const queryString = '?spedStudentCollectionToTemplateVersionId=' + spedStudentCollectionToTemplateVersionId;
    return this.http.post<void>(System.apiURL.SpecialEd + 'spedDeleteAssignedTemplate' + queryString, null);
  }

  spedEditAssignedCollectionTemplatesRead(studentCollectionId: number, collectionId: number): Observable<OptionalForms[]> {
    const queryString = '?studentCollectionId=' + studentCollectionId + '&collectionId=' + collectionId;
    return this.http.get<OptionalForms[]>(System.apiURL.SpecialEd + 'SpedEditAssignedCollectionTemplatesRead' + queryString);
  }

  spedEditAssignedCollectionRead(collectionToStudentId: number, templateVersionId: number[]): Observable<OptionalForms[]> {
    const queryString = '?collectionToStudentId=' + collectionToStudentId;
    return this.http.post<OptionalForms[]>(System.apiURL.SpecialEd + 'spedAssignTemplateToStudentCollection' + queryString, templateVersionId);
  }

  checkOutForm(studentXmlDataId: number, checkedOutByUserId: number, DoneByUser: boolean): Observable<void> {
    let queryString = '';
    queryString += '?studentXmlDataId=' + studentXmlDataId +
      '&checkedOutByUserId=' + checkedOutByUserId +
      '&DoneByUser=' + DoneByUser;
    return this.http.post<void>(System.apiURL.SpecialEd + 'CheckoutForm' + queryString, null);
  }

  teamMemberPermissionRead(spEdCollectionToStudentId: number, studentId: number): Observable<TeamMemberPermission[]> {
    const queryString = '?spEdCollectionToStudentId=' + spEdCollectionToStudentId + '&studentId=' + studentId;
    return this.http.get<TeamMemberPermission[]>(System.apiURL.SpecialEd + 'TeamMemberPermissionRead' + queryString);
  }

  spedTemplateFieldsRead(identificationId: number, dualIdentificationId: number, tertiaryIdentificationId: number, quaternaryIdentificationId: number, fifthIdentificationId: number): Observable<IdentificationSubCodes[]> {
    const queryString = '?identificationId=' + identificationId
      + '&dualIdentificationId=' + dualIdentificationId +
      '&tertiaryIdentificationId=' + tertiaryIdentificationId +
      '&quaternaryIdentificationId=' + quaternaryIdentificationId +
      '&fifthIdentificationId=' + fifthIdentificationId;
    return this.http.get<IdentificationSubCodes[]>(System.apiURL.SpecialEd + 'IdentificationSubCodes' + queryString);
  }

  saveIdentificationData(yearId: number): Observable<PickIdentification[]> {
    const queryString = '?yearId=' + yearId;
    return this.http.post<PickIdentification[]>(System.apiURL.SpecialEd + 'SaveIdentificationData' + queryString, this.pickIdentificationData);
  }

  getXMLCodesvalues(yearId: number): Observable<PickIdentification[]> {
    const queryString = '?yearId=' + yearId +
      '&studentId=' + this.pickIdentificationData.StudentId +
      '&studentCollectionTemplateVersionId=' + this.pickIdentificationData.StudentCollectionTemplateVersionId +
      '&templateName=' + this.pickIdentificationData.TemplateName +
      '&templateVersionId=' + this.pickIdentificationData.TemplateVersionId;
    return this.http.get<PickIdentification[]>(System.apiURL.SpecialEd + 'GetXMLCodes' + queryString);
  }

  getSpedStudentCollectionTeamMemberPermission(collectionToStudentId: number): Observable<string> {
    const queryString = '?collectionToStudentId=' + collectionToStudentId;
    return this.http.get<string>(System.apiURL.SpecialEd + 'StudentCollectionTeamMemberPermissionRead' + queryString);
  }

  saveTeamMember(collectionToStudentId: number, selectedStaffUserId: number, userIdIsFacultyStaffId: boolean): Observable<void> {
    let queryString = '';
    queryString += '?collectionToStudentId=' + collectionToStudentId +
      '&selectedStaffUserId=' + selectedStaffUserId +
      '&userIdIsFacultyStaffId=' + userIdIsFacultyStaffId;
    return this.http.post<void>(System.apiURL.SpecialEd + 'SyncTeamMember' + queryString, null);
  }

  spedUpdateTeamMember(data: SpedTeamMemberUpdate[]): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'SpedUpdateTeamMember', data);
  }

  deleteSpedTeamMember(collectionToStudentId: number, teacherUserId: number): Observable<boolean> {
    const queryString = '?collectionToStudentId=' + collectionToStudentId +
      '&teacherUserId=' + teacherUserId;
    return this.http.get<boolean>(System.apiURL.SpecialEd + 'SpedDeleteTeamMember' + queryString);
  }

  savePlaData(yearId: number): Observable<PlaMaintenance[]> {
    const queryString = '?yearId=' + yearId;
    return this.http.post<PlaMaintenance[]>(System.apiURL.SpecialEd + 'SavePLAAData' + queryString, this.plaMiantenanceData);
  }

  getPlaXMLvalues(yearId: number): Observable<PlaMaintenance[]> {
    const queryString = '?yearId=' + yearId +
      '&studentId=' + this.plaMiantenanceData.StudentId +
      '&studentCollectionTemplateVersionId=' + this.plaMiantenanceData.StudentCollectionTemplateVersionId +
      '&templateName=' + this.plaMiantenanceData.TemplateName +
      '&templateVersionId=' + this.plaMiantenanceData.TemplateVersionId +
      '&categoryName=' + this.plaMiantenanceData.CategoryName +
      '&rowIndex=' + this.plaMiantenanceData.RowIndex;
    return this.http.get<PlaMaintenance[]>(System.apiURL.SpecialEd + 'GetPLAAXmlData' + queryString);
  }

  saveCourseOfStudyData(yearId: number): Observable<PickCourseOfStudy[]> {
    const queryString = '?yearId=' + yearId;
    return this.http.post<PickCourseOfStudy[]>(System.apiURL.SpecialEd + 'SaveCourseOfStudyData' + queryString, this.courceOfStudyData);
  }

  checkSequence(data: FormListSequence[]): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'ChangeFormSequence', data);
  }

  getStudentCollectionTemplate(studentCollectionTemplateVersionId: number, templateName: string): Observable<StudentCollectionTemplate> {
    const queryString = '?studentCollectionTemplateVersionId=' + studentCollectionTemplateVersionId + '&templateName=' + templateName;
    return this.http.get<StudentCollectionTemplate>(System.apiURL.SpecialEd + 'GetStudentCollectionTemplate' + queryString);
  }

  spedMarkDocumentCompleted(teamMemberPermissionid: number, status: boolean): Observable<void> {
    const queryString = '?teamMemberPermissionid=' + teamMemberPermissionid + '&status=' + status;
    return this.http.post<void>(System.apiURL.SpecialEd + 'spedMarkDocumentCompleted' + queryString, null);
  }

}
